import React from 'react';
import { useLocation } from 'react-router-dom';
import { Container, Typography, Box, Card, CardContent, Grid } from '@mui/material';
import { motion } from 'framer-motion';
import { Event, Place, Person } from '@mui/icons-material';

const AmplifiedEventDetails = () => {
  const { state } = useLocation();
  const { event } = state || {};

  if (!event) {
    return (
      <Container maxWidth="md" sx={{ py: 4, bgcolor: '#f8f9fa', minHeight: '100vh' }}>
        <Typography variant="h6" sx={{ textAlign: 'center', color: '#2c3e50' }}>
          Error: No event data available
        </Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="md" sx={{ py: 4, bgcolor: '#f8f9fa', minHeight: '100vh' }}>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
        <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#2c3e50', mb: 4, textAlign: 'center' }}>
          {event.eventName}
        </Typography>

        <Box sx={{ mb: 2 }}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item>
              <Event sx={{ color: '#6200ee' }} />
            </Grid>
            <Grid item>
              <Typography sx={{ fontSize: '1rem', color: '#2c3e50' }}>
                {new Date(event.dateTime).toLocaleString()}
              </Typography>
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ mb: 2 }}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item>
              <Place sx={{ color: '#6200ee' }} />
            </Grid>
            <Grid item>
              <Typography sx={{ fontSize: '1rem', color: '#2c3e50' }}>
                {event.venue}
              </Typography>
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item>
              <Person sx={{ color: '#6200ee' }} />
            </Grid>
            <Grid item>
              <Typography sx={{ fontSize: '1rem', color: '#2c3e50' }}>
                Organized by: {event.organizer}
              </Typography>
            </Grid>
          </Grid>
        </Box>

        {[
          { title: 'Event Objective', content: event.objective },
          { title: 'Target Audience', content: event.targetAudience },
          { title: 'Event Theme', content: event.eventTheme || 'N/A' },
          { title: 'Schedule', content: event.schedule },
          { title: 'Key Speakers', content: event.keySpeakers || 'N/A' },
          { title: 'Workshops', content: event.workshops || 'N/A' },
          { title: 'Entry Requirements', content: event.entryRequirements || 'None' },
          { title: 'Parking & Transport', content: event.parkingTransport || 'N/A' },
          { title: 'Catering & Refreshments', content: event.cateringRefreshments || 'N/A' },
          { title: 'Dress Code', content: event.dressCode || 'N/A' },
          { title: 'Sponsorships', content: event.sponsorships || 'N/A' },
          { title: 'Contact Information', content: event.contactInformation },
        ].map((section, index) => (
          <Card key={index} sx={{ mb: 2, bgcolor: '#fff', borderRadius: 2, boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
            <CardContent>
              <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#6200ee', mb: 1 }}>
                {section.title}
              </Typography>
              <Typography sx={{ fontSize: '1rem', color: '#2c3e50', lineHeight: 1.5 }}>
                {section.content}
              </Typography>
            </CardContent>
          </Card>
        ))}
      </motion.div>
    </Container>
  );
};

export default AmplifiedEventDetails;